import type { SVGProps } from "react";
export interface SirenOnIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SirenOnIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SirenOnIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M6.615 18.152a1.125 1.125 0 0 1-2.23-.303zM14.38 5.875a4.125 4.125 0 0 1 4.087 3.568l1.147 8.406a1.125 1.125 0 0 1-2.23.303L16.24 9.747a1.875 1.875 0 0 0-1.858-1.622H9.62c-.937 0-1.732.693-1.859 1.622l-1.145 8.405L5.5 18l-1.115-.151 1.147-8.406.07-.378a4.126 4.126 0 0 1 4.017-3.19z"
      />
      <path
        fill={color}
        d="M10.16 9.386c.614.088 1.042.658.954 1.273l-.5 3.5a1.125 1.125 0 0 1-2.227-.319l.5-3.5a1.126 1.126 0 0 1 1.272-.954ZM3 8.875l.115.005a1.126 1.126 0 0 1 0 2.239L3 11.124H2a1.125 1.125 0 0 1 0-2.25zm19 0 .115.005a1.125 1.125 0 0 1 0 2.239l-.115.005h-1a1.125 1.125 0 0 1 0-2.25zM4.004 3.005a1.126 1.126 0 0 1 1.506-.078l.086.078.699.7.078.085A1.126 1.126 0 0 1 4.79 5.372l-.087-.076-.7-.7-.076-.085a1.125 1.125 0 0 1 .076-1.506Zm14.4 0a1.125 1.125 0 1 1 1.592 1.59l-.7.7a1.125 1.125 0 0 1-1.591-1.59zM10.877 3V2a1.125 1.125 0 0 1 2.25 0v1a1.126 1.126 0 0 1-2.25 0m9 17a.875.875 0 0 0-.877-.875H5a.874.874 0 0 0-.875.875v.875h15.75V20Zm2.25 1.5c0 .898-.729 1.625-1.627 1.625h-17A1.624 1.624 0 0 1 1.875 21.5V20A3.124 3.124 0 0 1 5 16.875h14A3.125 3.125 0 0 1 22.125 20v1.5Z"
      />
    </svg>
  );
}
